// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"298e822c","598":"ff34ac21","703":"0c2a6d7b"}[chunkId] + ".chunk.js";
};